module.exports = __webpack_public_path__ + "img/s5Img1Low.d99e65ab.png";